export const manufacturerWhitelist = [
	"Secureo",
	"Müller Safe",
	"Bordogna",
	"Wertheim",
	"PS GmbH",
	"Evva",
	"Sistec",
	"HMF",
	"Phoenix Safe",
	"BKS",
	"Abus",
	"Kruse",
	"Format",
	"Rottner Security",
	"CES",
	"Secureo by CES",
	"dormakaba",
	"Burg Wächter",
	"Blaupunkt",
	"Masunt",
	"Chubbsafes",
	"Sentry Safe",
	"Erwe Econ",
	"Nuki",
	"De Raat",
	"advanSecure",
	"ISS",
	"Sudhaus",
]

export const vendorBlacklist = []
